import { render, staticRenderFns } from "./ListGoods.vue?vue&type=template&id=180d8aa0&"
import script from "./ListGoods.vue?vue&type=script&lang=js&"
export * from "./ListGoods.vue?vue&type=script&lang=js&"
import style0 from "./ListGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListGoodsItem: require('/home/runner/work/myody_front/myody_front/components/list/ListGoodsItem.vue').default})
